export default {
  title: 'Excluir ícone do site',
  cancelLabel: 'Cancelar',
  deleteLabel: 'Excluir ícone',
  questionModal: 'Tem certeza que deseja excluir o ícone do site?',
  successNotification: 'O ícone foi excluído com sucesso.',
  failedNotification: 'Erro ao excluir ícone do site.'
}
